import d from "debug";
import { defaultDevEnableDebug, env } from "../utils/environment";
import appLogger from "../utils/logger";

/**
 * This is a real hack, but here's the deal: When we capture errors in the
 * service worker, we send them to Sentry, and we want logs included in the
 * created issue. For some reason, logs created using `debug` are not included
 * but logs created using `console` are (on the main thread, logs from `debug`
 * and `console` are captured).
 *
 * By using console.debug, we can capture logs in Sentry, but we lose the the
 * nice color coding. So for local development, we use `debug` and for
 * production, we use `console.debug`. This is not ideal, but it works.
 */

const debug = (namespace: string) => {
  if (env === "local") {
    return d(namespace);
  } else {
    return d.enabled(namespace) ? (...data: any[]) => console.debug(namespace, ...data) : () => {};
  }
};
if (defaultDevEnableDebug) {
  d.enable(defaultDevEnableDebug);
}

export const swLogger = appLogger.with(debug).with({ namespace: "sw", tags: { thread: "sw" } });
